import { useTranslation } from 'react-i18next'
import { useHistory, useParams } from 'react-router-dom'

import { ProductIds } from 'core/application/commons/config'
import getCompanyInfo, { CompanyInfoDetails } from 'core/application/csiDashboard/csiSearch/getCompanyInfo'

import useUrlQueryParam from 'common/hooks/useUrlQueryParam'

import { Button, Col, Item, Row, Skeleton, TabPane, Tabs } from 'common/components'
import { parseZoneFormat } from 'common/dateFormatters'
import { ROUTE_PATHS } from 'common/routePaths'

import RecurlyLogo from '../../../assets/images/RecurlyLogo'
import SalesforceLogo from '../../../assets/images/SalesforceLogo'
import BackNavigation from '../../../common/components/navigation/backNavigationTitle/BackNavigation'
import UseQueryRequest from '../../../common/hooks/useQueryRequest'
import GroupHraCompanyDetails from './groupHra'
import IchraCompanyDetails from './ichra'
import PerksCompanyDetails from './perks'
import QsehraCompanyDetails from './qsehra'

import './styles.less'

const CompanyDetails = () => {
  const history = useHistory()
  const { t: translate } = useTranslation()
  const searchValue = useUrlQueryParam('searchValue')
  const { companyId } = useParams<any>()
  const [companyInfo] = UseQueryRequest<CompanyInfoDetails | null>(null, () => getCompanyInfo(companyId ?? ''))

  return (
    <>
      <Skeleton active={true} loading={!companyInfo}>
        <Row>
          <Col>
            <BackNavigation
              title={companyInfo?.companyDetails.name}
              history={history}
              path={`${ROUTE_PATHS.CSI_SEARCH}?searchValue=${searchValue}`}
            />
          </Col>
        </Row>

        <Row>
          <Col md={24}>
            {companyInfo && (
              <div className="flex flex__space_between">
                <Item
                  translate={translate}
                  title={translate('csi-dashboard.company-details.customerId')}
                  text={companyInfo.companyDetails.id}
                />
                <Item
                  translate={translate}
                  title={translate('csi-dashboard.company-details.created-on')}
                  text={
                    companyInfo.companyDetails.createdAt ? parseZoneFormat(companyInfo.companyDetails.createdAt) : null
                  }
                />
                <Item
                  translate={translate}
                  title={translate('csi-dashboard.company-details.ended-on')}
                  text={companyInfo.companyDetails.endedOn ? parseZoneFormat(companyInfo.companyDetails.endedOn) : null}
                />

                <div className="flex">
                  <div className="mr-8">
                    <Button
                      type="default"
                      onClick={() => window.open(companyInfo.companyDetails.recurlyCustomerUrl, '_blank')}
                      customIcon={<RecurlyLogo />}
                    >
                      {translate('general.recurly')}{' '}
                    </Button>
                  </div>

                  <div>
                    <Button
                      type="default"
                      onClick={() => window.open(companyInfo.companyDetails.salesforceCustomerUrl, '_blank')}
                      customIcon={<SalesforceLogo />}
                    >
                      {translate('general.salesforce')}
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            {companyInfo && (
              <div className="tabsDetails">
                <Tabs type="card" tabPosition={'top'} centered>
                  {companyInfo.companyDetails.products.map((item) => (
                    <TabPane tab={item.name} key={item.id}>
                      {item.id === ProductIds.Perks && <PerksCompanyDetails companyInfoDetails={companyInfo} />}
                      {item.id === ProductIds.GroupHraId && <GroupHraCompanyDetails companyInfoDetails={companyInfo} />}
                      {item.id === ProductIds.QsehraId && <QsehraCompanyDetails companyInfoDetails={companyInfo} />}
                      {item.id === ProductIds.IchraId && <IchraCompanyDetails companyInfoDetails={companyInfo} />}
                    </TabPane>
                  ))}
                </Tabs>
              </div>
            )}
          </Col>
        </Row>
      </Skeleton>
    </>
  )
}

export default CompanyDetails
